var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-image',{attrs:{"kicker":"Cars and Tracks"}},[_c('h1',[_vm._v("Browse Cars & Tracks")])]),(!_vm.loading)?_c('b-container',{staticClass:"mt-3 mb-5"},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }